import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Button, Box, Grid} from 'views/components';
import {Translate, translate, DateTimePicker} from 'views/module';

import {getEventTimezoneAbbr} from '../dateTime';

import moment from 'moment-timezone';

const EditCaregiverClockOut = (props) => {
  const {closeModel, event, onUpdateCaregiverClockOut} = props;

  const type = 'clockOutConfirmation';
  const caregiverUpdates = event.caregiverUpdates;
  const caregiverUpdateIndex = caregiverUpdates.findIndex((e) => e.type === type);
  const caregiverUpdate = caregiverUpdates[caregiverUpdateIndex];
  const eventTimezone = event.eventData.timezone;

  const [clockOutTime, setClockOutTime] = React.useState(moment.tz(caregiverUpdate.data.suggestedClockoutTimeFormatted, eventTimezone));

  const [isSaving, setIsSaving] = React.useState(false);
  const timezoneAbbr = getEventTimezoneAbbr(clockOutTime, eventTimezone);

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    await onUpdateCaregiverClockOut(
        event.eventRn,
        type,
        moment(clockOutTime).toISOString(),
        () => {
          closeModel(true);
          setIsSaving(false);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression="schedule.eventDetail.ClockOutDialogTitle.Title" />
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="flex-start" sx={{mt: 0}}>
          <Grid item xs={12}>
            <DateTimePicker
              label={`${translate('schedule.eventDetail.EventTimelineSection.ShiftClockedOut.ClockoutTime')} (${timezoneAbbr})`}
              value={clockOutTime}
              onChange={setClockOutTime}
              textFieldProps={{fullWidth: true, InputLabelProps: {shrink: true}, helperText: eventTimezone, sx: {mt: 0}}}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving || !clockOutTime}
        >
          <Translate expression="generic.Save" />
        </Button>
      </Box>
    </Dialog>
  );
};

EditCaregiverClockOut.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onUpdateCaregiverClockOut: PropTypes.func.isRequired,
};

export default EditCaregiverClockOut;
